import { isNil, isString } from 'lodash'
import { isValidIBAN as _isValidIBAN, electronicFormatIBAN } from 'ibantools'

export const emailRegex = /^\S+@\S+\.\S+$/

export const isEmailValid = (email: string): boolean => {
    return !isNil(email.match(emailRegex))
}

export const isValidIBAN = (IBAN: string | undefined): boolean => {
    const formattedIBAN = electronicFormatIBAN(IBAN)
    return isString(formattedIBAN) && _isValidIBAN(formattedIBAN)
}

const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
export const isValidUUID = (uuid: unknown): boolean => {
    return isString(uuid) && uuidRegex.test(uuid)
}

const mongoIdRegex = /^[0-9a-f]{24}$/i
export const isValidMongoDBObjectId = (id: unknown): boolean => {
    return isString(id) && mongoIdRegex.test(id)
}
